/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 成长任务签到
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/member/level/sign-in`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
